module.exports = __webpack_public_path__ + "static/media/merkel.adcb9663.wav";